import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import classNames from 'classnames'
import { Funnel } from 'lucide-react'
import { SEARCH_TYPE_ICONS } from 'constants/search-icons'
import selectSearchMenu from 'redux/selectors/selectSearchMenu'
import { setCurrentSearchType } from 'redux/actions/search'
import Dropdown from 'components/Dropdown'

const DropDownSearchMenu = ({ inputRef }) => {
  const dispatch = useDispatch()
  const menuOptions = useSelector(selectSearchMenu)

  const options = menuOptions.map(({ title, typeName, icon }) => ({
    value: typeName,
    selected: false,
    label: (
      <div className='flex items-center'>
        {SEARCH_TYPE_ICONS[icon] && React.createElement(SEARCH_TYPE_ICONS[icon], { className: 'w6 mr5-half' })}
        {title}
      </div>
    )
  }))

  const handleSelect = (searchType) => {
    dispatch(setCurrentSearchType(searchType))

    if (inputRef?.current?.value?.trim()) {
      const form = inputRef.current.closest('form')
      form?.requestSubmit()
    }
  }

  return (
    <Dropdown
      handleOnSelect={handleSelect}
      chevron={false}
      testId='search-type-menu'
      label={(
        <div className='flex justify-center items-center'>
          <Funnel className='w6-m w7 light-slate-grey' />
        </div>
      )}
      options={options}
      classes={{
        button: ({ open }) => classNames(
          'hover-bg-casper-white focus-bg-casper-white h-100 w9 w8-m',
          {
            'bg-ghost-white': !open,
            'bg-casper-white': open
          }
        ),
        chevron: 'black',
        menu: 'bg-white',
        option: ({ focus }) => classNames(
          'black no-underline',
          {
            'bg-casper-white': focus,
            'bg-white': !focus
          }
        )
      }}
    />
  )
}

export default DropDownSearchMenu
